import gql from "graphql-tag";

export const updateNoticeModerationStatusMutation = gql`
  mutation updateNoticeModerationStatus($id: ID!, $moderationStatus: ModerationStatus) {
    updateNoticeModerationStatus(id: $id, moderationStatus: $moderationStatus) {
      id
    }
  }
`;
